import { useState } from "react";
import { Bell } from "lucide-react";
import { useFetch } from "@/hooks/useFetch";
import { fmtDate } from "@/lib/format";

// Preview of the weekly (Monday 9am IST) billing-due email to contract owners
export function BillingAlertsCard() {
  const { data } = useFetch("/lmo-register/billing-alerts");
  const [open, setOpen] = useState(false);
  if (!data) return null;
  const people = Object.entries(data.recipients || {});
  return (
    <div className="mb-3 rounded border border-amber-200 bg-amber-50/60 px-3 py-2 text-xs" data-testid="billing-alerts-card">
      <button className="flex items-center gap-2 font-semibold text-amber-900" onClick={() => setOpen(!open)} data-testid="billing-alerts-toggle">
        <Bell className="h-3.5 w-3.5" />Weekly billing-due alert (Mondays 9am IST): {data.line_count} line(s) due {fmtDate(data.from)} → {fmtDate(data.to)}, {people.length} contract owner(s)
      </button>
      {!data.email_configured && <p className="text-rose-700 mt-1" data-testid="billing-alerts-no-email">Email sending is not configured - alerts will not go out.</p>}
      {data.last_run && <p className="text-slate-500 mt-1" data-testid="billing-alerts-last-run">Last run {fmtDate(data.last_run.started_at)}: {data.last_run.status}{data.last_run.sent ? ` · sent to ${data.last_run.sent.length}` : ""}</p>}
      {open && <ul className="mt-1 space-y-0.5" data-testid="billing-alerts-list">
        {people.length ? people.map(([email, blocks]) => <li key={email}><b>{email}</b>: {blocks.map((b) => `${b.order_no} (${b.lines.length})`).join(", ")}</li>) : <li>No unbilled lines due in the next 7 days.</li>}
      </ul>}
    </div>
  );
}
